import { Box } from 'braid-design-system';
import React from 'react';

import * as styles from './ProgressBar.css';

interface Props {
  progress: number;
  labelId: string;
}

export const ProgressBar = ({ progress, labelId }: Props) => {
  const progressPercentage = (100 - progress * 100).toFixed(1);

  return (
    <Box
      background="neutralLight"
      borderRadius="full"
      overflow="hidden"
      role="progressbar"
      aria-valuenow={parseFloat(progressPercentage)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-labelledby={labelId}
      data={{ automation: 'profile-strength-progress-bar' }}
    >
      <Box
        className={styles.fill}
        background="positive"
        borderRadius="full"
        transition="fast"
        style={{
          transform: `translateX(-${progressPercentage}%)`,
        }}
      />
    </Box>
  );
};
